import { Box } from "@chakra-ui/react"
import Divider from "./Divider"

const DividerEdit = ({ layout, blockStyles }) => (
  <Box>
    <Divider layout={layout} blockStyles={blockStyles} />
  </Box>
)

export default DividerEdit
